import { Segment } from '@App/store/segment/types'

export enum Constants {
  SET_APPLICATIONS = 'SET_APPLICATIONS',
  SET_CURRENT = 'SET_CURRENT',
}

interface GetApplicationsAction {
  type: typeof Constants.SET_APPLICATIONS
  payload: IApplication[]
}

interface SetCurrentApp {
  type: typeof Constants.SET_CURRENT
  payload: any
}

export type ApplicationActionTypes = GetApplicationsAction | SetCurrentApp

export interface IApplication {
  id: number
  name: string
  label: string
  segments: Segment[]
}

export interface ApplicationState {
  list: IApplication[]
  current: any | null
}
